import { UPDATE_LAYOUT } from '../actions';

export const layout = (state = { mobile: false }, action) => {
  switch (action.type) {
    case UPDATE_LAYOUT:
      return Object.assign({}, {
        ...state,
        mobile: action.mobile
      });
    default:
      return state;
  }
}
